import { LOGIN } from '@/constants/path'
import { api } from '@/helpers/interceptors'
import router from '@/router'

const state = () => ({
  data: [],
  isLoggedIn: false,
  accessToken: '',
  isError: false,
  isLoading: false,
})

// getters
const getters = {
  token: (state) => {
    return state.accessToken
      ? state.accessToken
      : localStorage.getItem('token') ?? ''
  },
}

// actions
const actions = {
  /**
   * Login with emp_code / pass
   */
  async login({ commit, dispatch }, { emp_code, pass }) {
    try {
      commit('SET_LOADING', true)

      let bodyFormData = new FormData()
      bodyFormData.append('emp_code', emp_code)
      bodyFormData.append('pass', pass)
      bodyFormData.append('device_uuid', 'xxx')
      bodyFormData.append('platform', 'web')
      const res = await api(LOGIN, 'post', bodyFormData)
      const { access_token } = res?.data?.data
      if (access_token) {
        commit('SET_ACCESS_TOKEN', access_token)
        localStorage.setItem('token', access_token)
        dispatch('me/setData', res?.data?.data?.user_profile, {
          root: true,
        })
        if (res?.data?.data?.user_profile?.permission?.stock_view) {
          router.push({
            name: 'Dashboard',
          })
        } else {
          // If user doesn't have stock_view permission, redirect to 403 Forbidden page
          router.push({
            path: '/error/403',
          })
        }
      }
      commit('SET_LOGIN', true)
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_ACCESS_TOKEN', null)
      commit('SET_LOGIN', false)
      commit('SET_LOADING', false)

      throw error
    }
  },

  async logout({ commit }) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ACCESS_TOKEN', null)
      localStorage.clear()
      router.replace({ name: 'Login' })
      commit('SET_LOGIN', false)
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_ACCESS_TOKEN', null)
      commit('SET_LOGIN', false)
      commit('SET_LOADING', false)

      throw error
    }
  },
}

// mutations
const mutations = {
  SET_LOADING(state, payload = false) {
    state.isLoading = payload
  },
  SET_LOGIN(state, payload = false) {
    state.isLoggedIn = payload
  },
  SET_ACCESS_TOKEN(state, payload) {
    state.accessToken = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
